import { ref } from 'vue';

export const activeDropdownId = ref<string | null>(null);
export const openDropdownHierarchy = ref<string[]>([]); // 💡 tracks nesting chain

type DOMRefs = { trigger: HTMLElement | null; content: HTMLElement | null };
export const dropdownDOMRegistry = new Map<string, DOMRefs>();
